import { render, staticRenderFns } from "./YcTextArea.vue?vue&type=template&id=7f928d09&scoped=true&lang=pug&"
import script from "./YcTextArea.vue?vue&type=script&lang=js&"
export * from "./YcTextArea.vue?vue&type=script&lang=js&"
import style0 from "./YcTextArea.vue?vue&type=style&index=0&id=7f928d09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f928d09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
